import { render, staticRenderFns } from "./WithdrawalRequestDetailView.vue?vue&type=template&id=128f22ee&scoped=true"
import script from "./WithdrawalRequestDetailView.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequestDetailView.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRequestDetailView.vue?vue&type=style&index=0&id=128f22ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f22ee",
  null
  
)

export default component.exports